



















import { Component, Vue } from 'vue-property-decorator';
import myNav from '@/components/Nav.vue';

@Component({
  components: {
    myNav
  },
})
export default class production extends Vue {

  shouldFill: boolean = false; // 判断导航fixed定位后的填充
  $refs!: {
    stickyNav: HTMLElement,
    filler: HTMLElement,
  }

  path = "assets/solution/";

  //banner图相关参数
  bannerImgProportion = 612/1920;//控制banner图片的高度自适应比例
  bannerImgSrc ='';
  bannerImgSrcList = [
    require('@/'+this.path+'banner1.png'),
    require('@/'+this.path+'banner2.png'),
    require('@/'+this.path+'banner3.png'),
    require('@/'+this.path+'banner4.png'),
    require('@/'+this.path+'banner5.png'),
    require('@/'+this.path+'banner6.png'),
  ];

  // 导航路由列表
  navActiveIndex = 0;
  navList = [
    {url:'/selfService',label: '自助设备'},
    {url:'/ITservice',label: 'IT网络'},
    {url:'/businessScreen',label: '商用显示'},
    {url:'/guardService',label: '安防监控'},
    {url:'/intelFurniture',label: '智能家居'},
    {url:'/workService',label: '办公设备'},
  ];

  mounted() {
    let bannerHeight = document.body.clientWidth * this.bannerImgProportion;
    let nav = this.$refs.stickyNav;
    // document.addEventListener('scroll', ()=>{
    //   window.scrollY >= bannerHeight ? nav.classList.add('sticky') : nav.classList.remove('sticky');
    // })
    document.addEventListener('scroll', ()=>{
      if(window.scrollY >= bannerHeight){
        nav.classList.add('sticky');
        this.shouldFill = true;
      }else{
        nav.classList.remove('sticky');
        this.shouldFill = false;
      }
    });
  }

  created() {
    this.navActiveIndex = this.navList.findIndex(item=> item.url === this.$route.path);
    this.bannerImgSrc = this.bannerImgSrcList[this.navActiveIndex];
  };

  // 首页图片的高度自适应
  imgHeightChange(proportion: number){
    var wid = document.body.clientWidth
    var hei = 826
    if (wid > 1920) {
      hei = 826
    } else {
      hei = proportion * wid
    }
    var height = hei + 'px';
    return height;
  }

  handleSelect(item:any,index:number) {
    if(this.navActiveIndex!==index)        // 避免重复跳转
      this.$router.push(item.url);
    this.navActiveIndex=index;
    this.bannerImgSrc = this.bannerImgSrcList[index];

    // 导航条悬浮时，跳转回到导航条悬浮临界的位置
    if(this.$refs.filler) {
      document.body.scrollTop = document.documentElement.scrollTop = this.$refs.filler.offsetTop - 75;
    }
  }

}


